<svg [attr.viewBox]="'0 0 ' + VW + ' ' + vh()" (mouseleave)="hovered.set(null)">
    <text class="axis-title" [attr.x]="m.left" y="12" [style.fill]="color1()">{{ label1() }}</text>
    <text class="axis-title" [attr.x]="VW - m.right" y="12" text-anchor="end" [style.fill]="color2()">{{ label2() }}</text>
    <g [attr.transform]="'translate(' + m.left + ',' + m.top + ')'">
        @for (t of ticks1(); track t.v) {
        <line class="grid" x1="0" [attr.x2]="iw()" [attr.y1]="t.y" [attr.y2]="t.y" />
        <text class="tick" x="-10" [attr.y]="t.y" dy="0.32em" text-anchor="end" [style.fill]="color1()">{{ t.text }}</text>
        }
        @for (t of ticks2(); track t.v) {
        <text class="tick" [attr.x]="iw() + 10" [attr.y]="t.y" dy="0.32em" [style.fill]="color2()">{{ t.text }}</text>
        }

        @if (hoveredPt(); as hp) {
        <rect [style.fill]="color1()" fill-opacity="0.12" [attr.x]="hp.bandX" y="0"
                [attr.width]="hp.bandW" [attr.height]="ih()" />
        }

        @for (p of pts(); track p.i) {
        <rect [attr.x]="p.barX" [attr.y]="p.barY" [attr.width]="p.barW" [attr.height]="p.barH" [style.fill]="color1()" />
        }

        <path [attr.d]="path()" fill="none" [style.stroke]="color2()" stroke-width="2" />

        @for (p of pts(); track p.i) {
        <circle [attr.cx]="p.x" [attr.cy]="p.dotY" [attr.r]="hovered() === p.i ? 6 : 3.5" [style.fill]="color2()" />
        }

        @for (p of pts(); track p.i) {
        <text
            class="xlabel"
            [attr.x]="p.x"
            [attr.y]="ih() + 16"
            [attr.text-anchor]="rotate() ? 'end' : 'middle'"
            [attr.transform]="rotate() ? 'rotate(-45,' + p.x + ',' + (ih() + 16) + ')' : null"
        >{{ p.label }}</text>
        }

        @for (p of pts(); track p.i) {
        <rect class="hover-band" [attr.x]="p.bandX" y="0" [attr.width]="p.bandW" [attr.height]="ih()"
                fill="transparent" (mouseenter)="hovered.set(p.i)" />
        }
    </g>

    @for (l of legend(); track l.label) {
        <circle [attr.cx]="l.x + 4.5" [attr.cy]="vh() - 14" r="4.5" [style.fill]="l.color" />
        <text class="legend" [attr.x]="l.x + 15" [attr.y]="vh() - 10">{{ l.label }}</text>
    }

    @if (tip(); as t) {
        <g class="tip" [attr.transform]="'translate(' + t.x + ',' + t.y + ')'">
        <rect class="card" [attr.width]="t.w" [attr.height]="t.h" rx="6" />
        <text class="tip-title" x="12" y="21">{{ t.title }}</text>
        <line class="tip-rule" x1="12" [attr.x2]="t.w - 12" y1="29" y2="29" />

        <circle cx="17" cy="43" r="3.5" [style.fill]="color1()" />
        <text class="tip-label" x="27" y="47">{{ label1() }}</text>
        <text class="tip-val" [attr.x]="t.w - 12" y="47" text-anchor="end" [style.fill]="color1()">{{ t.v1 }}</text>

        <circle cx="17" cy="61" r="3.5" [style.fill]="color2()" />
        <text class="tip-label" x="27" y="65">{{ label2() }}</text>
        <text class="tip-val" [attr.x]="t.w - 12" y="65" text-anchor="end" [style.fill]="color2()">{{ t.v2 }}</text>

        @if (t.showReturns) {
            <circle cx="17" cy="79" r="3.5" [style.fill]="color3()" />
            <text class="tip-label" x="27" y="83">{{ t.retLabel }}</text>
            <text class="tip-val" [attr.x]="t.w - 12" y="83" text-anchor="end" [style.fill]="color3()">{{ t.retVal }}</text>
        }

        @if (t.rows) {
            <line class="tip-rule" x1="12" [attr.x2]="t.w - 12" [attr.y1]="t.ruleY" [attr.y2]="t.ruleY" />
            <text class="tip-section" x="12" [attr.y]="t.sectionY">{{ t.heading }}</text>
            @for (r of t.rows; track r.y) {
            <text class="tip-row-label" x="12" [attr.y]="r.y">{{ r.label }}</text>
            <text class="tip-row-val" [attr.x]="t.w - 12" [attr.y]="r.y" text-anchor="end">{{ r.value }}</text>
            }
        }
        </g>
    }
</svg>